import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column, InputText, Dialog, FileUpload, Toast, InputTextarea, RadioButton } from "primereact";
import "../../assets/css/badge.css";
import ListaLotti from "../DettagliProdotto/listaLotti";
import { Formik } from "formik";
import "../../assets/css/badge.css";

import ReactGA from "react-ga4";

class ListaProdotti extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (e) => {
          this.vai(e, "V");
          console.log("View");
        },
      },
      {
        id: 2,
        icon: "pi-pencil",
        label: "",
        action: (e) => {
          this.vai(e, "U");
          console.log("Edit");
        },
      },
      {
        id: 3,
        icon: "pi-trash",
        label: "",
        action: (e) => {
          this.vai(e, "D");
          console.log("Delete");
        },
      },
      {
        id: 4,
        icon: "pi-bookmark",
        label: "Associa Lotto",
        action: (e) => {
          this.prodottoid = e;
          this.setVisible2(true);
          console.log("View");
        },
      },

      {
        id: 5,
        icon: "pi-list",
        label: "Lista Lotti",
        action: (e) => {
          this.vailistalotti(e);
          console.log("View");
        },
      },
    ];

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      prodotti: [],
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
    };
    this.onPage = this.onPage.bind(this);
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&aziendaid=" + this.utente.aziendaid;
    axios
      .get(Costanti.UrlCallApi + "prodotto/all?" + quer, config)
      .then((res) => {
        res.data.prodotti.forEach((element) => {
          element.azioni = this.actions;
        });
        this.setState({ prodotti: res.data.prodotti, totalRecords: res.data.contaProdotto, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    this.caricaDati(1, this.state.pageSize);
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setVisible3(val) {
    this.setState({ visible3: val });
  }
  setVisible2(val) {
    this.setState({ visible2: val });
  }

  vai(id, tipo) {
    if (id == "0") {
      this.props.history.push("/prodotto/" + id + "/I");
    } else {
      if (tipo == "D") {
        this.props.history.push("/prodotto/" + id + "/D");
      }
      if (tipo === "U") {
        this.props.history.push("/prodotto/" + id + "/U");
      }
      if (tipo === "V") {
        this.props.history.push("/prodotto/" + id + "/V");
      }
    }
  }

  vailistalotti(id) {
    this.setState({ prodottoid: id });
    this.setVisible3(true);
  }

  salvaLotto(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    var dato = {
      datains: null,
      dataupd: null,
      id: 0,
      numero: values.numero,
      prodottoid: this.prodottoid,
      uteins: 1,
      uteupd: null,
      descrizione: values.descrizione,
      data1: values.data1,
      data2: values.data2,

      status: " ",
    };
    axios
      .post(Costanti.UrlCallApi + "lotti/aggiungi", dato, config)
      .then((res) => {
        this.showMessage("success", "Dati salvati correttamente", "");
        this.setState({ isSubmitting: false });
      })
      .catch((error) => {
        this.showMessage("error", "Errore nel salvataggio", error.message);
        this.setState({ isSubmitting: false });
      });
  }


  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/prodotti/" + this.utente.aziendaid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  scaricaqr() {
    let dati = {
      url: Costanti.BaseHttp,
    };

    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .post(Costanti.UrlCallApi + "stampe/listaqr/" + this.utente.aziendaid, dati, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <DataTable
          value={this.state.prodotti}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Prodotti</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
        
              <Button
                label="Esporta in Pdf"
                onClick={() => this.setPDF(true)}
                icon="pi pi-file-pdf"
                className="p-button-rounded p-button-danger "
              />
              <Button
                label="Lista QR-Code"
                onClick={() => this.scaricaqr()}
                icon="pi pi-qrcode"
                className="p-button-rounded p-button-info "
              />
              <Button
                label="Aggiungi"
                onClick={() => this.vai(0, "A")}
                icon="pi pi-plus"
                className="p-button-rounded p-button-primary "
              />
            </div>
          }
          responsiveLayout="stack"
        >
          <Column field="name" body={(item) => <img src={item.photoUrl} />} />
          <Column field="codiceprodotto" header="Codice Prodotto" />
          <Column field="immagine" header="Prodotto" />
          <Column field="nome" header="Nome" />
          <Column
            field="status"
            header="Stato"
            body={(item) => <span className={`customer-badge status-${item.status}`}>{item.status}</span>}
          />
          <Column
            field="allergeni"
            header={sessionStorage.getItem("Allergeni")}
            body={(item) =>
              sessionStorage.getItem("Allergeni") ? (
                <Checkbox disabled checked={item.allergeni >= 1} className="mr-4" />
              ) : (
                ""
              )
            }
          ></Column>

          <Column
            field="lotti"
            header="Lotti"
            body={(item) => <Checkbox disabled checked={item.lotti >= 1} className="mr-4" />}
          ></Column>
          <Column
            field="materie"
            header="Materie Prime"
            body={(item) => <Checkbox disabled checked={item.materie >= 1} className="mr-4" />}
          ></Column>
          <Column
            field="certificazioni"
            header="Certificazioni"
            body={(item) => <Checkbox disabled checked={item.certificazioni >= 1} className="mr-4" />}
          ></Column>
          <Column
            field="azIoni"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {item.azioni.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    //label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>
        <Dialog
          visible={this.state.visible3}
          closable={false}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "60vw" }}
          header="Lista Lotti"
          draggable={false}
          resizable={false}
          footer={
            <div className="border-top-1 surface-border pt-3">
              <Button icon="pi pi-check" onClick={() => this.setVisible3(false)} label="Chiudi" />
            </div>
          }
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <ListaLotti nascondiTestata={true} prodottoid={this.state.prodottoid} />
          </div>
        </Dialog>
        <Dialog
          header="Associa Lotto"
          closable={false}
          visible={this.state.visible2}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <Formik
                initialValues={{
                  numero: "",
                  prodotto: "",
                  descrizione: "",
                  data1: "",
                  data2: "",
                  prodottoid: this.prodottoid,
                }}
                enableReinitialize
                validationSchema={this.validationSchema}
                onSubmit={(values) => {
                  this.salvaLotto(values);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-wrap border-top-1 surface-border pt-4">
                      <div className="surface-card p-2  border-round">
                        <div className="grid formgrid p-fluid">
                          <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                          <div className="field mb-1 col-12 md:col-6">
                            <label htmlFor="numero" className="font-medium text-600">
                              Numero lotto
                            </label>
                            <InputText
                              id="numero"
                              name="numero"
                              value={values.numero}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              type="text"
                            />
                          </div>
                          <div className="field mb-1 col-12 md:col-6">
                            <label htmlFor="data1" className="font-medium text-600">
                              {sessionStorage.getItem("DecoLotto1")}{" "}
                            </label>
                            <InputText
                              id="data1"
                              name="data1"
                              type="date"
                              value={values.data1}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                          <div className="field mb-1 col-12 md:col-6">
                            <label htmlFor="data2" className="font-medium text-600">
                              {sessionStorage.getItem("DecoLotto2")}{" "}
                            </label>
                            <InputText
                              id="data2"
                              name="data2"
                              type="date"
                              value={values.data2}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                          <div className="field mb-1 col-12 md:col-6">
                            <label htmlFor="nickname2" className="font-medium text-600">
                              {sessionStorage.getItem("DecoStabilimento")}{" "}
                            </label>
                            <InputText id="nickname2" type="text" />
                          </div>
                          {this.lottoid > 0 ? (
                            <div className="field mb-1 col-12 md:col-6">
                              <label htmlFor="avatar2" className="font-medium text-600">
                                Multimedia
                              </label>
                              <div className="flex align-items-center">
                                <img src={this.state.imgsrc} width="20%" alt="" className="mr-4" />
                                <FileUpload
                                  id="avatar2"
                                  mode="basic"
                                  name="avatar"
                                  onError={() =>
                                    this.showMessage("error", "Errore", "Si è verificato un errore nel caricamento")
                                  }
                                  url={
                                    Costanti.UrlCallApi +
                                    "file/carica/" +
                                    this.utente.aziendaid +
                                    "/lotto/" +
                                    this.lottoid
                                  }
                                  onUpload={() => this.settaImg()}
                                  accept="image/*"
                                  maxFileSize={10000000}
                                  chooseOptions={{ className: "p-button-plain p-button-outlined" }}
                                  chooseLabel="Upload Image"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                          <div className="field mb-1 col-12 md:col-12">
                            <label htmlFor="descrizione" className="font-medium text-600">
                              Descrizione
                            </label>
                            <InputTextarea
                              id="descrizione"
                              type="text"
                              rows={10}
                              autoResize
                              value={values.descrizione}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <footer>
                      <div className="border-top-1 surface-border pt-3">
                        <Button type="submit" icon="pi pi-save" label="Salva" />
                        <Button
                          type="button"
                          icon="pi pi-check"
                          onClick={() => this.setVisible2(false)}
                          label="Chiudi"
                        />
                      </div>
                    </footer>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaProdotti;
